type Props = {
  onChange: (value: string) => void;
  presetValues: string[];
  max: number;
};

export const AmountPresetButtons = ({ onChange, presetValues, max }: Props) => {
  const onClickMaxHandler = () => {
    onChange(String(max));
  };

  const onClickHandler = (value: string) => {
    return () => {
      onChange(value);
    };
  };

  return (
    <div className="flex w-full justify-between gap-2">
      {presetValues.map((presetValue) => {
        return (
          <button
            type="button"
            className="msq-btn msq-btn-secondary msq-btn-sm w-full"
            key={presetValue}
            onClick={onClickHandler(presetValue)}
          >
            {presetValue}
          </button>
        );
      })}
      <button
        type="button"
        className="msq-btn msq-btn-secondary msq-btn-sm w-full"
        key="max-button"
        onClick={onClickMaxHandler}
      >
        Max
      </button>
    </div>
  );
};
